/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  func-names,
  import/extensions,
  import/no-extraneous-dependencies,
  no-void
*/
import './index.scss';
import React from 'react';
import ContentButton from 'signer/components/common/content-button';
import CheckPlatform from 'common/utils/check-platform';
import Header from 'common/components/headers/external/google-marketing/index.jsx';
import Footer from 'hellosign/components/app/footer';
import { messages, postMessage } from 'common/utils/messages';

import {
  FormattedMessage,
} from 'react-intl';
import ClosedImgSrc from './closed_@2x.png';


export default function SignatureRequestDeclineComplete(props) {

  const loginProps = props.app.login;
  const platform = CheckPlatform();
  const isEmbedded = props.app.isEmbedded();

  const closeIFrame = function () {
    const app = props.app;

    if (window.HelloSign) {
      HelloSign.XWM.send('user-done', app.signatureRequest.embeddedData.parentUrl);
    }

    if (app.isEmbedded()) {
      postMessage({
        type: messages.USER_FINISH_REQUEST,
      }, app.signatureRequest.embeddedData.parentUrl);
    }
  };


  const iFrameCloseButton = <ContentButton className='whitelabel-secondary-button' {...props} onClick={closeIFrame}>
    <FormattedMessage
      id="common.closeButton.labelText"
      description="button text of iFrame , clicking will close iFrame"
      defaultMessage="Close" />
  </ContentButton>;

  const main = (
    <div className='main'>
      <img src={ClosedImgSrc} />
      <h1>
        <FormattedMessage
          id="signer.decline.complete.documentClosed"
          description="text in modal of signer flow, when signer declines the signature request, the document as an signature request will close"
          defaultMessage="This document is now closed." />
      </h1>
      <h2>
        <FormattedMessage
          id="signer.decline.complete.emailConfirmation"
          description="text in modal of signer flow, informing signer will receive the confirmation of declining of signature request"
          defaultMessage="You'll receive an email confirmation shortly." />
      </h2>
      { isEmbedded ? iFrameCloseButton : void 0 }
    </div>
  );

  let footer;
  if (platform === 'desktop') {
    footer = <Footer siteCode='S' className='app-footer--signer' />;
  }

  const baseClass = `m-signature-request-decline-complete ${platform}`;
  let body;

  if (isEmbedded) {
    body = (
      <div className={baseClass}>
        { main }
      </div>
    );
  } else {
    body = (
      <div className={baseClass}>
        <Header {...loginProps} />
        { main }
        { footer }
      </div>
    );
  }

  return body;
}
